import { createIcon } from './create-icon'

export const Unlock = createIcon({
  displayName: 'Unlock',
  paths: [
    'M678.221 209.076c13.056 16.555 10.795 40.576-4.139 55.509-18.432 18.432-47.701 15.019-64.341-5.12-28.459-34.304-74.325-53.547-124.288-43.435-60.245 12.203-101.461 68.565-101.461 130.005v80.631h384.009c47.104 0 85.333 38.229 85.333 85.333v341.333c0 47.104-38.229 85.333-85.333 85.333h-512c-47.104 0-85.333-38.229-85.333-85.333v-341.333c0-47.104 38.229-85.333 85.333-85.333h42.658v-76.833c0-109.184 78.379-206.976 186.709-220.203 78.464-9.6 148.949 23.851 192.853 79.445zM768 853.333v-341.333h-512v341.333h512zM512 597.333c-47.104 0-85.333 38.229-85.333 85.333s38.229 85.333 85.333 85.333c47.104 0 85.333-38.229 85.333-85.333s-38.229-85.333-85.333-85.333z'
  ]
})
